import * as React from 'react';

import useRouter from 'js/lib/useRouter';

import PageDataErrorHandler from 'bundles/unified-description-page-common/components/shared/PageDataErrorHandler';
import PagePlaceholder from 'bundles/unified-description-page-common/components/shared/PagePlaceholder';
import {
  useCoursePageData,
  useCoursePageError,
  useIsCourseDataLoading,
} from 'bundles/unified-description-page-common/contexts/consumer/ConsumerBffCourseContext';
import {
  useIsS12nDataLoading,
  useS12nPageError,
  useSpecializationPageData,
} from 'bundles/unified-description-page-common/contexts/consumer/ConsumerBffSpecializationContext';
import useClientSideRouteCheck from 'bundles/unified-description-page-common/hooks/useClientSideRouteCheck';

type Props = {
  children: React.ReactNode;
};

// Ensure all conditions pass in order to show consumer description page
const ConsumerPageGuard = ({ children }: Props) => {
  useClientSideRouteCheck();
  const courseData = useCoursePageData();
  const s12nData = useSpecializationPageData();
  const isCourseDataLoading = useIsCourseDataLoading();
  const isS12nDataLoading = useIsS12nDataLoading();
  const courseDataError = useCoursePageError();
  const s12nDataError = useS12nPageError();
  const router = useRouter();

  if (isCourseDataLoading || isS12nDataLoading) {
    return <PagePlaceholder />;
  } else if (!courseData && !s12nData) {
    return <PageDataErrorHandler pathname={router.location.pathname} error={courseDataError || s12nDataError} />;
  } else {
    return <React.Fragment>{children}</React.Fragment>;
  }
};

export default ConsumerPageGuard;
